import CustomStore from "devextreme/data/custom_store";
import useApiConfiguration from "../apiConfig";
import { AllegatiTemporaneiApi } from "../data/apis";
import { useMemo } from "react";

export function useAttachmentDataSource() {
    const apiConfiguration = useApiConfiguration();

    const dataSource = useMemo(() => {
        const api = new AllegatiTemporaneiApi(apiConfiguration);

        return new CustomStore({
            key: "idAllegato",
            loadMode: "raw",
            load: (loadOptions) => {
                return api.getAttachments();
            }
        });
    }, []);

    return dataSource;
}